import * as React from 'react';
import {FunctionComponent, useState} from 'react';

import {RecurringEventUpdateType} from '../../../../../../Models/RecurringEventUpdateType';

interface OwnProps {
    allowedUpdateTypes: RecurringEventUpdateType[];
    onCancel: () => void;
    onSubmit: (type: RecurringEventUpdateType) => void;
}

export const EditRecurring: FunctionComponent<OwnProps> = ({allowedUpdateTypes, onCancel, onSubmit}) => {
    const [type, setType] = useState<RecurringEventUpdateType>(RecurringEventUpdateType.Single);

    return (
        <>
            <div className="modal-header">
                <h5 className="modal-title">Edit recurring event</h5>
            </div>
            <div className="modal-body">
                <div className="mb-3">
                    <div className="form-check m-3">
                        {allowedUpdateTypes.includes(RecurringEventUpdateType.Single) && (
                            <div className="row mb-3">
                                <div className="col-12">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="type"
                                        id="single"
                                        value={RecurringEventUpdateType.Single}
                                        checked={type === RecurringEventUpdateType.Single}
                                        onChange={() => setType(RecurringEventUpdateType.Single)}
                                    />
                                    <label className="form-check-label" htmlFor="single">
                                        This event
                                    </label>
                                </div>
                            </div>
                        )}

                        {allowedUpdateTypes.includes(RecurringEventUpdateType.Future) && (
                            <div className="row mb-3">
                                <div className="col-12">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="type"
                                        id="future"
                                        value={RecurringEventUpdateType.Future}
                                        checked={type === RecurringEventUpdateType.Future}
                                        onChange={() => setType(RecurringEventUpdateType.Future)}
                                    />
                                    <label className="form-check-label" htmlFor="future">
                                        This and following events
                                    </label>
                                </div>
                            </div>
                        )}

                        {allowedUpdateTypes.includes(RecurringEventUpdateType.All) && (
                            <div className="row">
                                <div className="col-12">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="type"
                                        id="all"
                                        value={RecurringEventUpdateType.All}
                                        checked={type === RecurringEventUpdateType.All}
                                        onChange={() => setType(RecurringEventUpdateType.All)}
                                    />
                                    <label className="form-check-label" htmlFor="all">
                                        All events
                                    </label>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="modal-footer justify-content-end">
                <button onClick={() => onCancel()} className="btn btn-transparent me-2">
                    Cancel
                </button>
                <button className="btn btn-primary" onClick={() => onSubmit(type)}>
                    Ok
                </button>
            </div>
        </>
    );
};
